import FootHead from "./FootHead";
import Subscribe from "./Subscribe";
import FootSub from "./FootSub";
import IconList from "./IconList";
import { useSelector } from "react-redux";

const Footer = () => {
  const { isAuth } = useSelector((state) => state.authReducer);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="block bg-white pb-4">
      <div className="flex">
        <div className="w-[10%] flex flex-col justify-end  ">
          <div className=" m-6">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              onClick={scrollToTop}
              className="cursor-pointer"
            >
              <path
                d="M22 29L22 15M22 15L16 21M22 15L28 21"
                stroke="#000000"
                strokeWidth="1.5"
              />
              <rect
                x="0.5"
                y="0.5"
                width="43"
                height="43"
                rx="21.5"
                stroke="#000000"
              />
            </svg>
          </div>
        </div>
        <div className="w-[25%] block pt-6">
          <img
            className="mb-12"
            src="/images/offsetGo-footer.svg"
            alt="offset-go logo"
          />
          <div className="">
            <IconList />
          </div>
        </div>
        <div className="w-[75%] block mr-20 items-right">
          <div className="mt-12 float-right">
            {/* <FootHead /> */}
            <div className="mt-8 float-right">
              <p className="text-4 font-normal text-right text-black pr-4 mb-4">
                Get the latest updates by subscribing your email
              </p>
              <div className="ml-[42%]">
                <Subscribe />
              </div>
              <div className=" ml-96 mt-12 mb-8">
                <FootSub />
              </div>
              {isAuth ? (
                <p className="text-4 font-normal text-right text-black pr-4">
                  How to use the Platform?
                </p>
              ) : (
                <p>{""}</p>
              )}
              <p className=" font-normal text-right text-xs text-footSubColor pr-4 mb-4">
                Copyright © 2025 Offset Global Technologies Private Limited.
              </p>
            </div>
          </div>
        </div>
      </div>

      <a href="https://www.offsetgo.earth/" target="_blank">
        <div className="h-24 w-[97%] rounded-2xl bg-[#1B6265] ml-4 pt-9 flex relative pointer-cursor">
          <div className="mb-14 ml-24">
            <p className="text-xl text-white font-bold">Visit our Website</p>
          </div>
          <div className="absolute right-10 mt-1">
            <a href="https://www.offsetgo.earth/" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M1.5749 16.4246L16.4241 1.57538M16.4241 1.57538L3.69622 1.57539M16.4241 1.57538L16.4241 14.3033"
                  stroke="#ECEEEC"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
      </a>
    </div>
  );
};

export default Footer;
